var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 4,
      expression: "4"
    }],
    class: _vm.$style.section
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('common.discount'))
    }
  }), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.displayDiscountAmount)
    }
  })]), _c('div', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 4,
      expression: "4"
    }],
    class: _vm.$style.section
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.displayCode)
    }
  }), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.displayDiscountValue)
    }
  })]), _c('div', {
    class: _vm.$style.section
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('common.total'))
    }
  }), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.displayAmountWithDiscount)
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }